module.exports = __webpack_public_path__ + "static/img/teacher-header.5587eb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teacher-header.png
// module id = 63
// module chunks = 0